import './index.scss'
import {
  StructuredListWrapper,
  StructuredListHead,
  StructuredListBody,
  StructuredListRow,
  StructuredListInput,
  StructuredListCell
} from 'carbon-components-react'

StructuredListWrapper.Head = StructuredListHead
StructuredListWrapper.Body = StructuredListBody
StructuredListWrapper.Row = StructuredListRow
StructuredListWrapper.Input = StructuredListInput
StructuredListWrapper.Cell = StructuredListCell
export {
  StructuredListWrapper,
  StructuredListHead,
  StructuredListBody,
  StructuredListRow,
  StructuredListInput,
  StructuredListCell,
  StructuredListWrapper as default
}
